<script setup lang="ts">
import { Box } from '@collector/shared-ui'
import { ParticipantWithLogo } from '@collector/shared-ui-domain'
import { useParticipants } from '@desktop/views/Relation/composables'

import Result from './Result.vue'

// composables
const { homeParticipant, awayParticipant } = useParticipants()
</script>

<template>
  <Box class="text-neutral-dark-0">
    <slot name="top" />
    <div class="flex">
      <div class="w-full">
        <slot name="home">
          <ParticipantWithLogo
            v-if="homeParticipant"
            class="justify-end"
            :participant="homeParticipant"
          />
        </slot>
      </div>
      <div class="flex min-w-28 items-center justify-center px-1">
        <slot name="result">
          <Result />
        </slot>
      </div>
      <div class="w-full">
        <slot name="away">
          <ParticipantWithLogo
            v-if="awayParticipant"
            class="justify-end"
            :participant="awayParticipant"
            reversed
          />
        </slot>
      </div>
    </div>
    <slot name="bottom" />
  </Box>
</template>
